import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import { reportClientEvent } from "@/lib/telemetry";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);

if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => {});
  });
}

// Globale Sicherung: nicht abgefangene Fehler / Promise-Rejections ins Audit-Log melden
// (ergaenzt die Error Boundary fuer Ereignisse ausserhalb des React-Renderings).
if (typeof window !== "undefined") {
  const seen = new Set();
  const report = (message, component) => {
    try {
      const key = String(message || "").slice(0, 120);
      if (!key || seen.has(key)) return;
      seen.add(key);
      reportClientEvent({ type: "client_error", message, component });
    } catch (e) {}
  };
  window.addEventListener("error", (e) => {
    report((e && (e.error?.message || e.message)) || "window error", "window.onerror");
  });
  window.addEventListener("unhandledrejection", (e) => {
    const r = e && e.reason;
    report((r && (r.message || String(r))) || "unhandledrejection", "promise.rejection");
    // Netzwerk-/API-Fehler (z. B. 401/403 aus Hintergrundabfragen) sind bereits protokolliert und
    // werden in der UI sauber behandelt — kein roter Dev-Overlay dafuer.
    if (r && (r.isAxiosError || r.response || r.config)) {
      e.preventDefault();
    }
  });
}
